import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ['procedureAmountInput', 'debtTotal', 'debtTotalHiddenField']

  updateDebtTotal() {
    let debtTotal = 0;
    this.procedureAmountInputTargets.forEach((input) => {
      const procedureAmount = parseFloat(input.value.replace(/\./g, '').replace(',', '.'))

      if (!isNaN(procedureAmount)) {
        debtTotal += procedureAmount
      }
    })

    const debtTotalFormated = Number(Math.round(debtTotal + 'e2') + 'e-2').toFixed(2).replace(".", ",")

    this.debtTotalTarget.innerHTML = debtTotalFormated
    this.debtTotalHiddenFieldTarget.value = debtTotalFormated
  }
}
